module.exports = __webpack_public_path__ + "img/learn-privately.7be117d.png";